import { forwardRef, memo } from 'react';

import { cn } from '../../lib/styles';
import { PageHeaderTitle } from './PageHeaderTitle';
import { PageHeaderDescription } from './PageHeaderDescription';

export interface PageHeaderGridProps extends Omit<React.HTMLAttributes<HTMLDivElement>, 'title'> {
  title: React.ReactNode;
  subTitle?: React.ReactNode;
  titleClassName?: string;
  titleSuffix?: React.ReactNode;
  left?: React.ReactNode;
  right?: React.ReactNode;
  description: React.ReactNode;
  descriptionClassName?: string;
}

const PageHeaderGridBase = (
  {
    title,
    subTitle,
    titleClassName,
    titleSuffix,
    className,
    left,
    right,
    description,
    descriptionClassName,
    ...rest
  }: PageHeaderGridProps,
  ref: React.ForwardedRef<HTMLDivElement>,
) => {
  return (
    <div
      ref={ref}
      className={cn('px-6 py-4', className)}
      style={{
        display: 'grid',
        gridTemplateAreas: left
          ? `'left title . right' 'left description description description'`
          : `'title . right' 'description description description'`,
        gridTemplateColumns: left ? 'auto auto 1fr auto' : 'auto 1fr auto',
        columnGap: 16,
        alignItems: 'center',
      }}
      {...rest}
    >
      {left && (
        <div style={{ gridArea: 'left' }} className="w-fit">
          {left}
        </div>
      )}

      <div className="overflow-hidden" style={{ gridArea: 'title' }} data-slot="title">
        <PageHeaderTitle className={titleClassName} suffix={titleSuffix} subTitle={subTitle}>
          {title}
        </PageHeaderTitle>
      </div>

      <div style={{ gridArea: 'description' }} data-slot="description">
        <PageHeaderDescription description={description} className={descriptionClassName} />
      </div>

      {right && <div style={{ gridArea: 'right' }}>{right}</div>}
    </div>
  );
};

export const PageHeaderGrid = memo(forwardRef(PageHeaderGridBase));
